import React, { ReactNode } from 'react';

import imgLogo from 'assets/img/check-unscreen.gif';
import styles from './CongratulationsModal.module.less';

type Props = {
  onClose?: () => void;
  content: ReactNode;
};

export default function CongratulationsModal(props: Props) {
  const { content, onClose } = props;

  return (
    <div className={styles.modalContent}>
      <div className={styles.modalImage}>
        <img src={imgLogo} alt="check" />
      </div>
      <div className={styles.modalTitle}>Congratulations!</div>

      {content}

      {onClose && (
        <div className={styles.closePopup} onClick={onClose}>
          <span className="icon icon-close-sm"></span>
        </div>
      )}
    </div>
  );
}
